import Fetch from 'jsx/common/util/_fetch';
type AddBody = {
  email: string;
};

export const add = async (body: AddBody) => {
  return Fetch.post(`/api/user/`, {
    body: JSON.stringify(body),
  });
};
